module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3YKP9M4sZNdI5Q3T87FfTk-93456c48e22bc6a1b8f7c6f1cdbfb853.jpg";